import { GetStaticPaths } from 'next'
import { Durations } from '@/constants/durations'
import { slugs } from '@/constants/slugs'
import { DefaultLayout } from '@/layouts/DefaultLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { Faq } from '@/services/FaqService'
import { getGuildPromotion, Promotion } from '@/services/GuildPromotionService'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { loadTranslations } from '@/utils/translate/translate-server'
import CabriniExclusiveSceneView from '@/views/ExclusiveSceneView/CabriniExclusiveSceneView'
import { getGuildApprovedTorchPosters } from '@/views/GuildSignupView/GuildSignupContext/GuildSignupContext'

interface CabriniExclusiveSceneProps {
  guildApprovedTorchPosters: string[]
  faqs: Faq[]
  promotion: Promotion | null
}

export const CabriniExclusiveScene: NextPageWithLayout<CabriniExclusiveSceneProps> = ({
  faqs,
  guildApprovedTorchPosters,
  promotion,
}) => {
  return (
    <CabriniExclusiveSceneView
      videoUrl="https://media.angelstudios.com/copied-content/masters/37cf128a-9754-4118-a157-4546cafed92d.m3u8"
      imageUrl="https://images.angelstudios.com/image/upload/v1711154057/Cabrini_Exclusive_Scene_Thumbnail_Option_2.webp"
      canonical="https://www.angel.com/m/cabrini-exclusive-scene/gift"
      faqs={faqs}
      guildApprovedTorchPosters={guildApprovedTorchPosters}
      promotion={promotion}
    />
  )
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [{ params: { locale: 'en', project: slugs.cabrini } }],
    fallback: 'blocking',
  }
}

export const getStaticProps = getStaticPropsErrorHandler<CabriniExclusiveSceneProps>(
  { filePath: 'pages/[locale]/m/cabrini-exclusive-scene/gift/index.tsx' },
  async ({ federationClient, locale, preview }) => {
    const [guildApprovedTorchPosters, promotion, translations] = await Promise.all([
      getGuildApprovedTorchPosters(),
      getGuildPromotion({
        opts: { locale, preview },
        isSupportLink: true,
        federationClient,
      }),
      loadTranslations(locale, ['common', 'the-shift-exclusive', 'guild']),
    ])

    return {
      props: {
        faqs: [],
        promotion,
        guildApprovedTorchPosters,
        ...translations,
      },
      revalidate: Durations.FIFTEEN_MINUTES_IN_SECONDS,
    }
  },
)

CabriniExclusiveScene.getLayout = (page) => {
  return (
    <DefaultLayout isDarkMode hideNavigation>
      {page}
    </DefaultLayout>
  )
}

export default CabriniExclusiveScene
